var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundFallDeojasmimbranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 460,
    viewBox: "0 0 1440 460",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L1440 86.4395V459.799H0V0Z",
    fill: "#F9BF0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundFallDeojasmimbranco);
export default __webpack_public_path__ + "static/media/background_fall_deojasmimbranco.acea72068d29c92daa8b0ed276755426.svg";
export { ForwardRef as ReactComponent };